import Image from 'next/image';
export const SF6Logo = ({ size = 96 }: { size?: number }) => {
  const scale = 0.76;
  const nudgeX = 0;
  const nudgeY = -1;
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      className={`w-[${size}px] h-[${size}px] rounded flex items-center justify-center`}
    >
      <Image
        src="/sf6_logo_cropped.png"
        width={size * scale}
        height={size * scale}
        style={{
          transform: `translate(${nudgeX}px, ${nudgeY}px)`,
        }}
        alt="Street Fighter 6"
      />
    </div>
  );
};
